import { useEffect, useRef, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from '../../store';
import { AppDispatch } from '../../store';
import {
  fetchChatLogs,
  updateChatViewLog,
  setSelectedMonthYear,
} from '../../store/slices/chatHistorySlice';
import { ChatLogsT } from '../../types/chat';
import { chatEndpoints } from '../../services/api/endpoints/chat.endpoint';
import { logger } from '../../utils/logger';

export const useChatLogs = () => {
  const dispatch = useDispatch<AppDispatch>();

  const {
    items: chatLogs,
    isLoading,
    error,
    unreadCount,
    selectedMonthYear,
  } = useSelector((state: RootState) => state.chatLogs);

  // Use ref to track if initial fetch has been done
  const initialFetchDone = useRef(false);

  const selectedOrganizationId = useSelector(
    (state: RootState) => state.organizationContext.selectedOrganizationId
  );

  const fetchData = useCallback(async () => {
    if (!selectedOrganizationId) return;
    await dispatch(fetchChatLogs(selectedOrganizationId));
  }, [dispatch, selectedOrganizationId]);

  const setMonthYear = useCallback(
    async (monthYear: string) => {
      if (selectedOrganizationId) {
        dispatch(setSelectedMonthYear(monthYear));
      }
    },
    [dispatch, selectedOrganizationId]
  );

  // useEffect(() => {
  //   // Only fetch on mount or when organizationId changes
  //   if (!initialFetchDone.current || selectedOrganizationId) {
  //     fetchData();
  //     initialFetchDone.current = true;
  //   }
  // }, [selectedOrganizationId]);

  const refetch = useCallback(() => {
    if (selectedOrganizationId) {
      return dispatch(fetchChatLogs(selectedOrganizationId));
    }
  }, [dispatch, selectedOrganizationId]);

  const updateChatLog = async (data: ChatLogsT) => {
    try {
      const result = await chatEndpoints.updateChatLog(selectedOrganizationId, data.uuid, {
        isViewed: true,
      });
      dispatch(updateChatViewLog(data));
      return result;
    } catch (err) {
      const message = err instanceof Error ? err.message : 'Failed to fetch chat logs';
      logger.error('Error fetching chat logs:', message);
    }
  };

  return {
    isLoading,
    error,
    chatLogs,
    unreadCount,
    refetch,
    updateChatLog,
    setMonthYear,
    selectedMonthYear,
  };
};
